import { useState, useEffect } from 'react';
import { databasePromise } from './firebaseConfig';
import { ref, onValue } from "firebase/database";

export function useDestinations() {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    databasePromise
          .then((database) => {
            if (database) {
              const destinationsRef = ref(database, '/');
              const unsubscribe = onValue(
                destinationsRef,
                (snapshot) => {
                  const data = snapshot.val();
                  if (data) {
                    const destinationsArray = Array.isArray(data) ? data : Object.values(data);
                    setDestinations(destinationsArray);
                  } else {
                    setDestinations([]);
                  }
                  setLoading(false);
                },
                (error) => {
                  console.error("Error fetching destinations:", error);
                  setDestinations([]);
                  setLoading(false);
                }
              );

              return () => unsubscribe();
            }
            else{
              console.error("Database is not initialized.");
              setLoading(false);
              setDestinations([]);
              return;
            }  
          });
  }, []);

  // Always return an object, never undefined
  return { destinations, loading };
}